<div class="spen-ly-modal filter-multiple" id="modal" data-cy="filter-by-multiple">
  <div class="modal-dialog">
    <div class="inner">
      <div class="modal-heading">
        @if (authUserService.isStudent()) {
          <span class="top-btn-close" (click)="closeFilter()">
            <i class="fa fa-times" aria-hidden="true"></i>
          </span>
        }
        <h2 class="heading-text">検索</h2>
      </div>

      <div class="modal-content">
        @if (dataLoaded()) {
          <div class="box-filter">
            <form [formGroup]="form">
              <div class="row" [class.no-border]="authUserService.isStudent()">
                <div class="col-md-3 col-xs-12 align-center">
                  <p class="label-input">キーワード</p>
                </div>
                <div class="col-md-9 col-xs-12">
                  <input class="spen-mod-input-text" placeholder="キーワードを入力してください" formControlName="keyword" />
                </div>
              </div>
              <div class="row block-category" [class.no-border]="authUserService.isStudent()">
                <div class="col-md-3 col-xs-12 align-center">
                  <p class="label-input">カテゴリー</p>
                </div>
                <div class="col-md-9 col-xs-12">
                  <app-categories-selection [categories]="categories" formControlName="category_id"> </app-categories-selection>
                </div>
              </div>
              <div class="row block-activity-type" [class.no-border]="authUserService.isStudent()">
                <div class="col-md-3 col-xs-12 align-center">
                  <p class="label-input">種別</p>
                </div>
                <div class="col-md-9 col-xs-12">
                  <label class="spen-mod-select">
                    <select class="select" formControlName="activity_type">
                      @for (activityType of ACTIVITY_TYPES; track $index) {
                        <option class="select-option" [ngValue]="activityType.value">
                          {{ activityType.text }}
                        </option>
                      }
                    </select>
                    <i class="fa fa-caret-down"></i>
                  </label>
                </div>
              </div>
              <div class="block-marks" [class.no-border]="authUserService.isStudent()">
                <app-marks-selector [selectedIds]="selectedMarkIds" [centeredLabel]="true" [marks]="marks"></app-marks-selector>
              </div>
              <div class="row" [class.no-border]="authUserService.isStudent()">
                <div class="col-md-3 col-xs-12 align-center">
                  <p class="label-input">コメント状況</p>
                </div>
                <div class="col-md-9 col-xs-12">
                  <label class="spen-mod-select">
                    <select class="select" formControlName="comment_status" (change)="selectCommentStatus(form.value.comment_status)">
                      @for (commentStatus of COMMENT_STATUSES; track $index) {
                        <option class="select-option" [ngValue]="commentStatus.value">
                          {{ commentStatus.text }}
                        </option>
                      }
                    </select>
                    <i class="fa fa-caret-down"></i>
                  </label>
                  <label class="spen-mod-select select-child">
                    <select class="select" formControlName="sub_comment_status">
                      @for (subCommentStatus of SUB_COMMENT_STATUSES; track $index) {
                        <option class="select-option" [ngValue]="subCommentStatus.value">
                          {{ subCommentStatus.text }}
                        </option>
                      }
                    </select>
                    <i class="fa fa-caret-down"></i>
                  </label>
                </div>
              </div>
              <div class="row last-row" [class.no-border]="authUserService.isStudent()">
                <div class="col-md-3 col-xs-12 align-center">
                  <p class="label-input">公開状況</p>
                </div>
                <div class="col-md-9 col-xs-12">
                  <label class="spen-mod-select">
                    <select class="select" formControlName="public_status" (change)="selectPublicStatus(form.value.public_status)">
                      @for (publicStatus of PUBLIC_STATUSES; track $index) {
                        <option class="select-option" [ngValue]="publicStatus.value">
                          {{ publicStatus.text }}
                        </option>
                      }
                    </select>
                    <i class="fa fa-caret-down"></i>
                  </label>
                  <label class="spen-mod-select select-child">
                    <select class="select" formControlName="sub_public_status">
                      @for (subPublicStatus of SUB_PUBLIC_STATUSES; track $index) {
                        <option class="select-option" [ngValue]="subPublicStatus.value">
                          {{ subPublicStatus.text }}
                        </option>
                      }
                    </select>
                    <i class="fa fa-caret-down"></i>
                  </label>
                </div>
              </div>
            </form>
          </div>
        } @else {
          <div class="modal-content">
            <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
          </div>
        }
      </div>

      <div class="modal-footer">
        <div class="modal-actions is-right-actions">
          <a class="cancel spen-mod-btn is-default js-close-modal-trigger" data-cy="close-filter" (click)="closeFilter()">キャンセル</a>
          <a class="spen-mod-btn is-primary" data-cy="submit-filter" (click)="onSubmit()">検索する</a>
        </div>
      </div>
    </div>
  </div>
</div>
